import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  TOGGLE: `${cleanedFilename(__filename)}-toggle`,
};
